import React from 'react'
import PropTypes from 'prop-types'
import { HeartIcon, Badge } from 'components'

const SexualOrientation = ({ text, id, classNames }) =>
  id === 'open' ? null : (
    <Badge
      text={text}
      classNames={classNames}
      icon={<HeartIcon className="w-3.5 text-white opacity-40" />}
    />
  )

SexualOrientation.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  classNames: PropTypes.shape({
    text: PropTypes.string,
  }),
}

SexualOrientation.defaultProps = {
  classNames: {},
}

export default SexualOrientation
